<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/26XIS5/tc-custom/9781250302762.jpg?1737763725884" alt="This image is the cover for the book In the Black"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Black
      </h1>
      <p class="bookDescription body article font2">
        <b>“Tomlinson offers space opera fans much to chew on in this fun, fast-moving series debut . . . Readers are sure to be entertained.” —<i>Publishers Weekly</i></b><br/><br/>It’s The Hunt for Red October in space, with this brand new military science fiction novel from Patrick S. Tomlinson.<br/><br/>In a demilitarized zone on the border of human space, long range spy satellites are mysteriously going quiet, and no one knows why. Captain Susan Kamala and her crew are dispatched to figure out what’s going on and solve the problem.<br/><br/>That problem, however, is a mysterious, bleeding edge alien ship that no human vessel could hope to match in open conflict. But, it’s not spoiling for a fight.<br/><br/>Now, the Captain and her crew must figure out how to navigate a complicated game of diplomacy, balancing the needs of their corporate overlords, and the honest desire for a lasting peace between the two races, all without letting a long-standing cold war turn hot.<br/><br/><b>“Tomlinson is back with another crowd-pleasing, snarky, thought-provoking, character-driven tale.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick S. Tomlinson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25feb294